var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0071bc",
    fillRule: "evenodd",
    d: "M-13 0h80v40h-80z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M31.2 30.5s1.2-1.4 2.4-1.1c.4-1.4 1.8-1.5 1.8-1.5s-.1-1.6 1.6-2c0-1 1.1-1.9 1.1-1.9s-.2-1.6 1-2c-.7-1.3.2-2.3.2-2.3s-1.2-2-.2-2.6c-1-1-.7-2-.7-2s-1.2-.3-.8-1.7c-1-.2-1.1-1.7-1.1-1.7s-1.5.3-1.7-1c-1 .1-1.1-.9-1.1-.9s-2 .6-2.4-1c-.7.5-1-.2-1-.2s-1.1.5-1.8-.5c-1.3.8-2 0-2 0s-1.7 1-2.3.2c-1 1-1.9.6-1.9.6s-.7 1.3-2 1c-.2 1.2-1.6 1.2-1.6 1.2s.1 1.1-1.5 1.4C16.9 13.8 16 14 16 14s0 1.3-.8 1.7c.3.7-.4 1.6-.4 1.6s.8 1-.3 2c1 .3.3 2 .3 2s1.4.7.5 1.9c1 .3.7 1.1.7 1.6.7.3 1.2.1 1 1.4 2 .3 1 1.4 1 1.4s1 0 .6.7c1.7 0 2 1.3 2 1.3s1.5-.4 1.7.2-.7 4.7-.7 4.7-1.3 0-2.3-1c-2.3-.1-1.8-1.6-1.8-1.6s-.8.3-1.2-1c-1.5.3-1.5-1-1.5-1s-.7-.3-.4-1c-1.6.2-1.5-1.4-1.5-1.4q-.6-.2-.4-.8c-.3 0-1.7 0-1-2-1.3-.8-.4-1.7-.4-1.7s-2-1-.5-2c-1-1.7.1-2.5.1-2.5s-1.5-1.5 0-2.5c-.1-2.3 1.3-3 1.3-3s-.8-1.8 1.2-2.6c.1-2 1.5-2 1.5-2s0-1.5 2.2-1.3c.4-1.4 1.8-1.1 1.8-1.1s.5-1.6 2.5-.8c1-2 2.5-1 2.5-1s1-.6 1.4-.4c.6-1 2 0 2.7.1.3 0 1.4-.9 2.2.1 1.1-.7 2 .6 2 .6s1.6-.8 2.3 1c3.2-.3 2.8 1.8 2.8 1.8s2.5-.6 2 2c2.2 0 2 1.6 2 1.6s1.4 1.1.8 2c1.3.2.8 1.4.8 1.4s1 .4.2 2c1.9 1.4.4 3 .3 3 0-.1 1 1.1.1 2.5.3 2.3-.8 2.9-.8 2.9s.3 1.4-1 1.8c0 1.7-1.6 2-1.6 2s.4.7-1.2 1.5c0 1.1-1.7 1.2-1.7 1.2s-.2 2.1-2.3 1.5c-.5 1.7-3 1.2-3 1.2l-.5-3.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M15.7 10.3s.6.5.5 1.2q-.4 1.2-.4 2.4v.8s-.5-.7-.5-1.4c0-.8.5-1.5.5-2zm-.2.3s-.7.6-.8 1.3l-.1 2.5-.1 1.4c0 .3.5-.5.5-1.2v-2.4l.2-.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    fillRule: "evenodd",
    stroke: "#ef8a10",
    strokeWidth: 0.2,
    d: "M30.8 8.4s1-.4 1.2-1.2c.3-.8-.8-.8-1-.6 0 .3.2.9.1 1 0 .2-.4.6-.3.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    fillRule: "evenodd",
    stroke: "#ef8a10",
    strokeWidth: 0.3,
    d: "M22.8 8.7s.6-.9.4-1.7-1-.3-1 0 .5.7.5.9zm-1.6.4s.6-.8.5-1.6c-.2-.8-1.1-.3-1.1 0s.5.7.5.9zm-1.7.6s.5-.8.4-1.6c-.2-.8-1-.3-1 0l.5.8v.8Zm-1.3 1.2s.6-.8.5-1.6c-.2-.8-1.1-.3-1.1 0s.5.7.5.9zM17 12.1s.6-.8.4-1.6-1-.3-1 0 .5.7.5.8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    fillRule: "evenodd",
    stroke: "#ef8a10",
    strokeWidth: 0.2,
    d: "M20 5.1s-.9.7-1 1.5 1 .6 1 .3c.2-.3-.2-.8-.2-1q.2-.4.1-.7Zm2.5-.8s-.8.7-.8 1.5 1 .6 1 .3l-.3-1q.2-.4.1-.8Zm-9.7 7s.2 1 .8 1.5 1-.5.8-.7-.9-.1-1-.2q-.2-.5-.6-.5Zm-1.3 3.4s0 1 .6 1.6c.6.5 1-.4.9-.6-.2-.3-.9-.3-1-.4q-.2-.4-.5-.6Zm3 3.8s-.4-1-1.1-1.3-.8.7-.6.9h1c.2 0 .5.5.7.3Zm-.6-1.7s.6-.8.4-1.6c0-.8-1-.3-1 0s.5.7.5.9zm18.8-7.6s.9-.4 1.1-1.2-.7-.8-.9-.6v1c0 .2-.4.6-.2.8Zm2.7 1.3s.5-.8.3-1.6-1-.2-1 0 .5.7.6.9zm7.5 7.8s-.4-1-1.1-1.2c-.8-.4-.9.7-.6.8h1q.4.4.7.4Zm-3.7.6s0-1 .7-1.6c.6-.5 1 .4.8.7l-1 .3c0 .1-.3.6-.5.6Zm-.6-10.6s-.9-.4-1.6 0 0 1.1.2 1c.3 0 .6-.6.7-.7q.5 0 .7-.3Zm-2.1-1.8s-1-.3-1.7 0c-.7.4 0 1.1.3 1 .3 0 .5-.6.7-.7q.5 0 .7-.3Zm-3.2-1.7s-.8.6-.8 1.4c-.1.9.9.6 1 .4l-.3-1q.2-.5.1-.8Zm-2-.5s-.4 1 0 1.7c.3.7 1 0 1-.3s-.7-.5-.8-.7c0-.1 0-.7-.2-.7Zm-6 3.6s.7-.8.6-1.6-1-.3-1 0l.5.8q-.1.5 0 .8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8a8c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M28.9 9.5s1.5.1 1.6 1q-.2 1.4-.4 1.4s.2 2-1.3 2.5c-1.6.2-4.1 0-4.1 0s-.8.2-1-1.3l-.5-2.6s.2-.9 1.3-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "M30.1 12s-.8 1-.7 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c8a8c",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M29 14.4q.3 0 .5 1v1.2l1.1 9.8 1 7v1s-.2.9-.8 1c-.5 1-3 1.2-3.2 1.2s-1-.4-1.6-.3l-1.7.3c-.3 0-1.2-.4-1.3-1-1.1-.3-1.3-1.1-1.3-1.1l1.2-8.1 1-10.3s.2-1.4.8-1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "m23.2 28.4-.2 7.2m7.2-6.2.6 6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41.6 24.4v.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6b18b5",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "m11 15 .5 1q0 .8.4 1.4c.2.3 1.4 2 1.5 2.7 0 .5-.5 1.3-1.3 1.3-.4 0-1.6-.3-1.7-1.3s.4-1 .5-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6b18b5",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m19 6-.8.3-1.2 1c-.8.6-2.2 1-2.6 1.5-.2.4-.2 1.3.4 1.7.4.2 1.6.6 2.2-.2.5-.9.2-1.1.5-1.7Q18 7.2 19 6.1Zm12-1.2-.9-.4-1.4-.1c-1.1-.2-2.3-1-3-.9q-.8.3-1 1.5c.2.4.7 1.3 1.7 1.2s1-.4 1.6-.6c1.4-.8 2.9-.7 3-.7Zm11.7 11.5-.2-1q0-.5-.6-1.3c-.5-1-.4-2.4-.9-3-.3-.2-1.2-.5-1.7 0-.3.4-1 1.4-.3 2.2.7.7 1 .5 1.5.9 1.1.7 1.6 2 2.2 2.2Zm-.4 8.9q.3-.4.4-1l.1-1.4c.1-1.1.8-2 .6-3q-.2-.9-1.5-1c-.4.2-1.4.8-1.1 1.8s.5 1 .7 1.5c.6 1.2.2 2.7.8 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M34.1 32.2s-.2.4.6.7m1-1.5s.8-.2 1.3 0m1.1-2.1.6.9m0-1.9s.4.4 1.2.4m-6.3.7s0 1-.4 1.4m2.1-2.9s.8.2 1.5-.1m3.7-1.3q-.1.2 1 .2M37 26s1 .4 1.7 0m.3-4 .4 1m.4-4.1s0 .6-.5.8m3.6-3.3s-.7.6-.6.8M39.4 16s.4.6-.2 1m-1.5-3.6s.6 0 .9.5m-2-2.2h.4m2-2.2-.1.4m-4.4-.4s.4.6.3 1.2m1.7-3 .6-.2m-2.8-1.8s-.2.6.2.9m-1 2c0 .8.6.6.2 1.3M32.2 8l-.9.8M30 7.7s.4.4.3.9M29 7.4s-.2.6-.4.7M27 7.3l-.5.8m-2.2-.8s.3.6 0 1m-.6-4-.2.8m-2.4.2s.1.5-.6.6m-.9 3.8.8.2m-2.6 1.5 1-.3m-2.4 1.4h.8M16 13q.2-.2 0 1m-2.8-3.5.3.5M12 13s.4.6.8.7m2 2 .6-.1m-.9 2.1.4-.6m-1 1.5s.4.6.7.6m-1 .4c.1 0 .6-.4 1-.3m-1 1.7s0 .4 1.3.3m-1.2 1.3s.3-1 1.1-1.3m0 2.4q-.2-.1.7-.7m0 2.2.6-.5m0 1.6s.2.3 1-.2m-4.5.5s1.1-.3 1.5.3m-1.1.6s1.1-.2 1.2 0m2.8.2s-.2.3 1.2-.2m.5.7c-.3.4 0 .8-.3 1m-3.9-.4s.5-.2.4-.8m0 1.8s.8-.3 1-.2m.5 1.2s.1-.7.3-.8m.9 1.8s.6 0 .9-.2m.3-2.1s.6.3 1.8 0m-1.3 2.8.1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M41.5 18.8q0-.5-.4-.7-.3-.1-.5.1l-.2.7q0 .5.3.7h.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M41.4 17.3q0-.4-.4-.6-.3-.2-.5 0l-.2.8q0 .4.3.6t.6 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m41 15.7-.3-.6q-.4-.1-.6.1l-.1.8q0 .5.4.6.3.1.5-.1t.2-.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M40.5 14.1q-.1-.3-.5-.5-.4 0-.5.3v.7q.3.5.6.5t.5-.2V14Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M40 12.8q-.3-.5-.6-.5t-.5.2v.8l.6.5q.4 0 .5-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M39.1 11.5q-.2-.5-.6-.5t-.4.3v.7q.4.5.7.5t.5-.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m38.2 10.2-.6-.4q-.4 0-.5.3t.2.8l.7.4q.4 0 .4-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M37.1 9q-.4-.3-.7-.3-.4 0-.4.4 0 .3.3.7.4.3.7.3.4 0 .4-.4 0-.3-.3-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M35.9 7.9q-.4-.3-.7-.2-.4 0-.4.4 0 .3.4.7t.7.2q.4 0 .3-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M34.6 7q-.5-.2-.8 0-.3 0-.3.4l.5.6q.4.2.8.1.3-.1.2-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M33.1 6.3q-.5-.3-.7 0-.4 0-.3.4t.5.6h.8q.3-.1.2-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M31.7 5.7q-.5-.1-.8 0-.3.2-.2.5.2.3.6.5h.7q.3-.2.2-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M30.2 5.2h-.7q-.3.3-.2.6.2.3.6.5h.7q.3-.3.2-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m28.6 5-.7.1q-.3.3-.1.6t.7.4q.4 0 .7-.2t0-.6l-.6-.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M27 4.9q-.5 0-.7.2-.3.3 0 .6t.7.3.7-.3q.2-.3 0-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M25.5 4.9q-.4 0-.7.2v.6q.3.3.7.3.5 0 .7-.2.3-.3 0-.6zm-1.7.2q-.4 0-.6.4 0 .4.2.6t.7.1.6-.4-.1-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M22.3 5.5q-.5.1-.6.5 0 .3.2.5h.7q.4 0 .6-.4.1-.3-.1-.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M20.9 6.1q-.5.2-.5.5-.1.5.2.6h.8l.5-.6q0-.5-.2-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M19.5 6.8q-.5.3-.5.6t.3.5l.7-.1q.5-.2.5-.6t-.3-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M18.1 7.7q-.3.3-.4.7 0 .4.4.4l.7-.2q.4-.2.4-.6t-.3-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M17 8.7q-.4.2-.4.6t.3.5.7-.3.4-.6-.4-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M15.8 9.8q-.3.3-.3.7t.4.4.7-.3.3-.7-.4-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m14.9 11-.3.8q0 .4.5.3.3 0 .6-.3t.3-.7-.4-.4l-.7.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m14 12.4-.2.7q.2.3.5.3.4 0 .6-.4.3-.3.2-.7t-.4-.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M13.3 13.8q-.2.5 0 .8.1.3.5.2.3-.1.5-.5v-.8q0-.3-.4-.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M12.7 15.4v.7q.3.3.6.2t.5-.6V15q-.2-.3-.6-.2zm-.4 2.9.2.6h.5l.4-.5q0-.4-.2-.6h-.6q-.3 0-.3.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de2010",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M12.4 17v.7q.4.3.6 0 .3-.1.5-.5l-.1-.8q-.3-.3-.6-.1l-.4.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe300",
    fillRule: "evenodd",
    d: "M40.3 16.2q.3-.3.6-.1 0-.8-.4-.7-.3 0-.2.8m.3 1.5q.3-.2.6 0 0-.9-.4-.7-.3 0-.2.7m-.6-2.9q0-.3.5-.3-.4-.6-.6-.5-.3.2 0 .8m-.7-1.4q.2-.3.5-.3-.3-.6-.6-.5-.3.3 0 .8M37.7 11q0-.3.4-.4-.4-.6-.7-.4-.1.3.3.8m-1.1-1.1q0-.4.4-.4-.4-.6-.7-.4-.1.3.3.8M34.4 8q0-.4.2-.5-.6-.4-.7-.1-.1.2.5.6m1.1.9q0-.4.4-.5-.6-.5-.7-.2-.2.2.3.7M33 7.2q0-.4.2-.6-.6-.3-.7 0t.5.6m-1.3-.6.1-.6q-.6-.2-.7 0 0 .5.6.6M30.2 6l.1-.6q-.7-.1-.7.2t.6.4m-1.4-.3v-.5q-.7-.2-.7.1t.7.4m-1.5 0q-.3-.4 0-.7-.8 0-.8.3t.8.3m-3 .2-.2-.6q-.7 0-.6.4 0 .3.8.2m1.5-.2q-.3-.3-.1-.6-.7 0-.7.3t.7.3m-3 .5-.2-.6q-.7.3-.6.5.2.4.8 0M20 7.2q-.3 0-.3-.5-.7.5-.5.6.2.3.8 0m1.3-.6q-.3-.2-.2-.6-.7.3-.6.6.2.2.8 0m-3.8 2.4q-.3-.1-.4-.5-.6.6-.3.7.2.3.7-.2m1.2-1q-.3 0-.4-.4-.6.3-.4.6.3.2.8-.2m-2.2 2q-.4 0-.5-.4-.6.6-.2.7.2.2.7-.3m-1 1.2q-.3 0-.4-.3-.5.6-.3.7.3.2.7-.4m-.7 1.3q-.4 0-.6-.3-.5.6 0 .8.2 0 .6-.6m-.7 1.3q-.5 0-.6-.2-.3.7 0 .8.3 0 .6-.6m-.6 1.3H13q-.1.6.2.7t.4-.7m-.4 1.6h-.5q-.2.6.1.6t.4-.6m-.1 1.2q-.3.2-.6 0 0 .7.3.6t.3-.6m25.6-6q0-.3.4-.4-.4-.6-.6-.4-.4.3.2.8m2 7h.6q0-.8-.3-.7-.3 0-.2.8",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M38.8 11s-.6.6-.5 1.3l.5 2.2-.3 1.2s.7-.7.7-1.5c0-.7-.4-1.7-.4-2.2zm1 2.3q-.2 0-.4 1.1c0 .8.9 2.2.9 2.2s.5 1.1.5 1.4v-1c0-.6-.9-2-.9-2l-.1-.9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b18b5",
    fillRule: "evenodd",
    d: "M26.4 4q0-.3-.4-.3t-.4.3l.4.2q.4 0 .4-.2m.2.6q0-.2-.4-.3t-.4.3.4.3.4-.3m.5-.8s-.5.4-.3.5c.2.2.7-.3.7-.3zm13.6 8-.1-.3h-.3v.5h.3zm-.2-.7q0-.3-.2-.3t-.3.3.3.3zm.1 1.4v-.2q-.2 0-.2.2l.1.1zm.4-1.2V11q-.2 0-.2.2l.1.1zm-1 0h-.2v.2zm.1 1-.2-.2-.2.2q0 .3.2.3t.2-.3m-.5-.4-.2-.2-.2.2q0 .2.2.2zm-.1-.6-.2-.1h-.1v.3a.1.1 0 0 0 .2 0zm2.5 3q-.4-.6-.8-.4-.4.3 0 .8t.8.3 0-.8m.6 5.5q0-.6-.4-.8-.4 0-.5.7t.4.7q.4 0 .5-.6m.2 3.2q0-.6-.4-.8-.4 0-.6.6 0 .6.3.8.5 0 .7-.6m.6-3q0-.3-.2-.3t-.3.3.3.2.2-.2m-.6.6-.4.5-.4.1c0 .2.6.6.6.8h.3l.4-1s0-.6-.2-.6zm-29.7-.2a.2.2 0 0 0-.2-.3.2.2 0 1 0 .2.3m.2-.7-.2-.2q-.3 0-.3.2t.3.3a.2.2 0 0 0 .2-.3m-1.8-3.1q-.1-.3-.4-.2-.2 0 0 .4 0 .3.3.2t.1-.4m.5 2q-.1-.4-.5-.3-.3.1 0 .5 0 .4.4.3.3 0 .1-.6m.6 1.4q0-.5-.3-.6t-.4.4.3.6.4-.4m-1 .2q.3-.5 0-.7-.3 0-.5.4v.6q.5.1.6-.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b18b5",
    fillRule: "evenodd",
    d: "M11.3 19.6q0-.3-.3-.3t-.2.3l.2.2q.3 0 .3-.2m-.2-.7-.2-.2-.2.2q0 .3.2.3zm.2-1.1q0-.4-.2-.4t-.2.4.2.3zm.6-.1-.1-.5q-.2 0-.3.4t.2.4zm4.6-9.2q.1-.5-.2-.7-.3 0-.5.4 0 .5.2.7.3 0 .5-.4m-.9 1.3q.5-.3.3-.7-.2-.1-.7.2t-.2.6q.2.2.6 0m-.5-.7q.5-.4.3-.6t-.7.1-.2.6zm2-1.3q.3-.2.2-.4h-.5l-.2.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b18b5",
    fillRule: "evenodd",
    d: "M16 9q.3-.2.1-.4l-.4.2v.5l.4-.3m1.6-.7q.2-.3.1-.5l-.5.1-.2.5zM14.9 10q.3 0 .3-.2l-.4-.2q-.2 0-.2.2t.3.2M18 7.3q.2-.3 0-.4l-.4.2v.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    fillRule: "evenodd",
    stroke: "#ef8a10",
    strokeWidth: 0.1,
    d: "M37.6 12.8s.5-.9.3-1.7-1-.2-1 .1.5.7.5.8q0 .5.2.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M27.4 5.8s2 0 2 1.3l-.1 1q.6-.4.5-1.2c0-1.2-1.7-2.1-2.4-1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M26.2 5.7s1.5-.3 1.5 1c0 1.2-.5 1.4-.5 1.4s1.2-.3 1.2-1.5c0-1.3-1.5-1.9-2.2-.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7df73",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M31.4 32.5s7.3-2 9.5-11c-1.3 9.2-9.2 12-9.2 12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M32.2 33c.2 0 .8-.6 1-.6q.6-.3 0-.4-.5.2-.6.4l-.7.3c-.3 0 0 .4.3.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    stroke: "#8c1800",
    strokeWidth: 0.3,
    d: "M36.3 30s-.7.4-.6.5l.8-.4s.3-.4-.2-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M33.7 32s-.2-.2.4-.4.5-.5.7-.6.6-.4.7-.2q-.1.4-.6.5l-.8.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 0.4,
    d: "m37.5 28.8-.5.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "m38.2 28-.5.5m1.3-1.7-.6.8m1.2-2-.5.8m.7-1.5v.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "m40.2 24-.2.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7df73",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M22 32.3s-7.2-2-9.4-11.1a15 15 0 0 0 9.1 12.2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M21.2 32.9c-.2 0-.7-.7-1-.7q-.6-.3 0-.4.5.2.6.4l.7.3c.3 0 0 .5-.3.4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    stroke: "#8c1800",
    strokeWidth: 0.3,
    d: "M17.1 29.7s.7.5.6.6l-.7-.5s-.3-.3.1-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8c1800",
    fillRule: "evenodd",
    d: "M19.7 31.7s.2 0-.4-.3l-.7-.6q-.5-.3-.6-.2c-.1.1.4.5.5.5l.8.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 0.4,
    d: "m16 28.6.5.5m-1.2-1.4.4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 0.3,
    d: "m14.5 26.5.5.8m-1.1-2.1.4 1m-.7-1.6.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c1800",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "m13.3 23.7.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M41.2 20c0 .5.6 1 .4 2-.3 1.1-1.3 3.7-1.1 4.2q-.3-.6-.3-1.3c0-.6.8-2.6 1-3.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M41.2 20s.9 1 .8 2-.5 1.9-.3 2.4q-.4-.6-.4-1.2c0-.6.4-1.2.3-1.8 0-.5-.4-1.4-.4-1.4Zm-29.1.2c0 .6-.5 1-.2 2 .2 1.1 1.2 2.5 1 4.1q.4-.6.4-1.4c0-.5-1-2.3-1.1-3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#217900",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M12 20.2s-.8 1.1-.7 2c0 .6 1 3 1 3.5.2-.4.3-.3.3-1-.4-1.4-1-2.4-.8-3 0-.6.3-1.5.3-1.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "m26.9 10.3 2.1 6.6h7l-5.6 4 2.1 6.7-5.6-4-5.6 4 2-6.6-5.6-4.1h7z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp);
export default __webpack_public_path__ + "static/media/mp.20cf0df2b3b98803a3830e4ec00bfd1c.svg";
export { ForwardRef as ReactComponent };